import React, { useEffect, useState } from 'react';
import { UpdateTemplateEmail } from '@services/TemplateEmail/Index.jsx';
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import ButtonComp from '@components/UI/Button/Index.jsx';
import ValidationsTemplateEmail from '@validations/TemplateEmail/Validations.jsx';
import InputTextModalComp from '@components/UI/InputTextModal/Index.jsx';
import SelectOptionModalComp from '@components/UI/SelectOptionModal/Index.jsx';
import { emailTypes } from "@enums/TemplatesEmail/Index.jsx";
import TextAreaModalComp from '@components/UI/TextAreaModal/Index.jsx';
import { Modal } from 'antd';

function EditTemplateEmailModal({ onUpdate, visible, closeModal, selectedRow }) {

  const [tempValues, setTempValues] = useState({
    nome: '',
    titulo: '',
    tipoEmail: null,
    conteudo: '',
  });

  useEffect(() => {
    if (selectedRow) {

      setTempValues({
        nome: selectedRow.nome,
        titulo: selectedRow.titulo,
        tipoEmail: emailTypes.find(option => option.value === selectedRow.tipoEmail),
        conteudo: selectedRow.conteudo,
      });
    }
  }, [selectedRow]);

  const checkIsDirty = () => {
    return (
      selectedRow.nome !== tempValues.nome ||
      selectedRow.titulo !== tempValues.titulo ||
      selectedRow.tipoEmail !== tempValues.tipoEmail?.value ||
      selectedRow.conteudo !== tempValues.conteudo
    );
  };

  const handleTempChange = (field, value) => {
    setTempValues(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const onSubmit = async () => {
    try {
      if (!checkIsDirty()) {
        SweetAlert.error("Erro", "Nenhuma alteração foi feita nos dados.");
        return;
      }

      const { validateFields, validateTags } = ValidationsTemplateEmail();
      const errors = validateFields(tempValues);

      if (Object.keys(errors).length > 0) {
        const errorMessage = Object.values(errors).join("\n");
        SweetAlert.error("Erro na Validação", errorMessage);
        return;
      }

      // 1. Valida as tags no campo conteudo
      const tagsValidation = validateTags(tempValues.conteudo);

      // 2. Se inválido, mostra erro e aborta
      if (!tagsValidation.valid) {
        const invalidTagsMessage = tagsValidation.invalidTags.length > 0
          ? `As seguintes tags são inválidas: ${tagsValidation.invalidTags.join(', ')}`
          : tagsValidation.message;

        SweetAlert.errorHTML('Erro de validação', invalidTagsMessage);
        return;
      }

      const payload = {
        nome: tempValues.nome,
        titulo: tempValues.titulo,
        tipoEmail: tempValues.tipoEmail.value,
        conteudo: tempValues.conteudo,
      };

      SweetAlert.loading();

      const result = await UpdateTemplateEmail(selectedRow.id, payload);

      onUpdate({ ...result });

      closeModal();

      SweetAlert.success('Atualização Concluída!', 'Os dados foram atualizados com sucesso.');
    } catch (error) {

      const errorMessage = error.parsed?.message || 'Não foi possível atualizar o template de e-mail.';

      SweetAlert.errorHTML('Erro ao atualizar', errorMessage);
      console.error("Erro ao salvar atualizações", errorMessage);
    }
  };

  const handleCloseWithReset = () => {
    setTempValues({
      nome: selectedRow.nome,
      titulo: selectedRow.titulo,
      tipoEmail: emailTypes.find(option => option.value === selectedRow.tipoEmail),
      conteudo: selectedRow.conteudo,
    });
    closeModal();
  };

  return (
    <Modal
      getContainer={false}
      open={visible}
      onCancel={handleCloseWithReset}
      centered
      footer={null}
      width={800}
      title={<h5 className="fw-bold">Edição de Template de E-mail</h5>}
    >
      <hr />

      <InputTextModalComp
        label={"Nome Template"}
        value={tempValues.nome}
        onChange={(e) => handleTempChange('nome', e.target.value)}
        placeholder={"Preencher com um nome para template"}
        hoverMessage={"Preencher um um nome para template"}
        maxLength={255}
      />

      <InputTextModalComp
        label={"Título E-mail"}
        value={tempValues.titulo}
        onChange={(e) => handleTempChange('titulo', e.target.value)}
        placeholder={"Preencher com um título para o e-mail"}
        hoverMessage={"Preencher com um título para o e-mail"}
        maxLength={255}
      />

      <SelectOptionModalComp
        label={"Tipo E-mail"}
        options={emailTypes}
        value={tempValues.tipoEmail}
        onChange={(selected) => handleTempChange("tipoEmail", selected)}
        placeholder="Selecionar o tipo do e-mail"
        hoverMessage="Selecionar o tipo do e-mail"
        isDisabled
      />

      <TextAreaModalComp
        label={"Conteúdo"}
        value={tempValues.conteudo}
        onChange={(e) => handleTempChange("conteudo", e.target.value)}
        placeholder={"Preencher com o conteúdo do e-mail"}
        hoverMessage={"Preencher com o conteúdo do e-mail"}
        //maxLength={255}
        style={{ height: '20rem', resize: 'none' }}
      />

      <div className="d-flex justify-content-end gap-2 mt-4">
        <ButtonComp
          title="ATUALIZAR"
          buttonColor="#2b97be"
          classnameIcon="fa-regular fa-floppy-disk"
          onClick={onSubmit}
          hoverMessage={"Botão para confirmar a atualização"}
        />

        <ButtonComp
          title="CANCELAR"
          buttonColor="#dc3545"
          classnameIcon="fa-regular fa-circle-xmark"
          onClick={handleCloseWithReset}
          hoverMessage={"Botão para cancelar a atualização"}
        />
      </div>
    </Modal>
  );
};

export default EditTemplateEmailModal;